var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15.29,
    viewBox: "0 0 18 15.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dropbox",
    d: "M4.5,2.71,0,5.577,4.5,8.444,9,5.577Zm9,0L9,5.576l4.5,2.866L18,5.576ZM0,11.31l4.5,2.867L9,11.31,4.5,8.444ZM13.5,8.444,9,11.31l4.5,2.867L18,11.31Zm-9,6.689L9,18l4.5-2.866L9,12.267Z",
    transform: "translate(0 -2.71)",
    fill: "#bf0a76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.bfb1ac932334018c68191651dfc13f13.svg";
export { ForwardRef as ReactComponent };